<template>
  <div class="wrapper">
    <div class="header-wrapper">
      <div class="header">社区报到人员名单</div>
      <div class="addManager">
        <Upload
            style="display: inline;"
            :show-upload-list="false"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :headers="header"
            :action="actionuri"
            :on-success="handleSuccess"
            :on-progress="handleProgress"
            :on-error="handleError"
          >
            <Button :loading="uploadLoading" type="primary">导入</Button>
        </Upload>
        <Button class="bkcc-btn" @click="exportFile">下载模板</Button>
        <Button class="bkcc-btn" @click="loadData">搜索</Button>
        <Button class="bkcc-btn" @click="searchReset">重置</Button>
      </div>
    </div>
    
    <div class="content">
      <Card>
        <i-form ref="searchForm" :model="query">
          <row :gutter="20">
            <i-col span="6">
              <form-item label="姓名" prop="name">
                <i-input
                  v-model="query.name"
                  clearable
                  placeholder="请填写姓名"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="手机号" prop="tel">
                <i-input
                  v-model="query.tel"
                  clearable
                  placeholder="请填写手机号"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="职务/职级" prop="position">
                <i-input
                  v-model="query.position"
                  clearable
                  placeholder="请填写职务/职级"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="单位" prop="unit">
                <i-input
                  v-model="query.unit"
                  clearable
                  placeholder="请填写单位"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="具体地址" prop="address">
                <i-input
                  v-model="query.address"
                  clearable
                  placeholder="请填写具体地址"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="社区" prop="community">
                <Cascader
                  v-model="comList"
                  :data="communityList"
                  placeholder="请选择"
                  clearable
                  change-on-select
                ></Cascader>
              </form-item>
            </i-col>
          </row>
          
        </i-form>
      </Card>
      <Card class="card" style="margin-top: 20px">
        <Table border :columns="columns" :data="data" :loading="loading"></Table>
        <div class="page">
          <Page :total="total" :current="pageNum" @on-page-size-change="changePageSize" show-total :page-size="pageSize" :page-size-opts="[10,15,20,50,100,200]" @on-change="page" show-sizer/>
        </div>
      </Card>
    </div>

    <Modal
      v-model="editModal"
      title="编辑"
      width="660px"
      height="400px"
    >
      <i-form ref="editForm" :model="editData" :rules="editRules">
        <row :gutter="20">
          <i-col span="12">
            <form-item label="姓名" prop="name">
              <i-input
                v-model="editData.name"
                clearable
                placeholder="请填写姓名"
              />
            </form-item>
          </i-col>
          <i-col span="12">
            <form-item label="手机号" prop="tel">
              <i-input
                v-model="editData.tel"
                clearable
                placeholder="请填写手机号"
              />
            </form-item>
          </i-col>
          <i-col span="12">
            <form-item label="社区">
              <Cascader
                class="communityData"
                v-model="editData.communityData"
                :data="communityList"
                :placeholder="editData.community || '请选择'"
                clearable
                change-on-select
              ></Cascader>
            </form-item>
          </i-col>
          <i-col span="12">
            <form-item label="单位" prop="unit">
              <i-input
                v-model="editData.unit"
                clearable
                placeholder="请填写单位"
              />
            </form-item>
          </i-col>
          <i-col span="12">
            <form-item label="职务/职级" prop="position">
              <i-input
                v-model="editData.position"
                clearable
                placeholder="请填写职务/职级"
              />
            </form-item>
          </i-col>
          <i-col span="12">
            <form-item label="具体地址" prop="address">
              <i-input
                v-model="editData.address"
                clearable
                placeholder="请填写具体地址"
              />
            </form-item>
          </i-col>
        </row>
        
      </i-form>
      <div slot="footer">
        <Button @click="closeModel">取消</Button>
        <Button @click="editSubmit" :loading="btnLoading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
var that;
import { Page,Table } from "view-design";
const querystring = require("querystring");
export default {
  components:{
    Page,
    Table
  },
  data() {
    return {
      actionuri: "",
      uploadLoading: false,
      btnLoading: false,
      
      header: {
        token: window.sessionStorage.getItem("token"),
      },
      comList: [],
      communityList: [],
      editModal: false,
      editRules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        tel: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { type: "string", pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号", trigger: "blur" },
        ],
        unit: [
          { required: true, message: "请输入单位", trigger: "blur" },
        ],
        position: [
          { required: true, message: "请输入职务/职级", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入具体地址", trigger: "blur" },
        ],
      },
      editData: {
        id: "",
        name: "",
        community: "",
        unit: "",
        position: "",
        address: "",
        tel: "",
        communityData:[]
      },
      query: {
        name: "",
        position:'',
        tel: "",
        unit: "",
        address: "",
        community: ""
      },
      columns: [
        {
          title: "姓名",
          key: "name",
          align:'center',
          width:110
        },
        {
          title: "手机号",
          key: "tel",
          align:'center',
          width:135
        },
        {
          title: "社区",
          key: "community",
          align:'center',
          width:220
        },
        {
          title: "单位",
          key: "unit",
          align:'center',
          width:220
        },
        {
          title: "职务/职级",
          key: "position",
          align:'center',
          width:220
        },
        {
          title: "具体地址",
          align:'center',
          key: "address"
        },
        {
          title: "操作",
          width:180,
          align:'center',
          render: function(h, params) {
            return h("div", [
              h(
                "Button",
                {
                  props:{
                    type:"dashed"
                  },
                  on: {
                    click: () => {
                      that.edit(params.row);
                    }
                  }
                },
                "编辑"
              ),
              h("Divider",
                {
                  props:{
                    type:"vertical"
                  }
                }
              ),
              h(
                "Button",
                {
                  props:{
                    type:"error",
                    ghost:true
                  },
                  on: {
                    click: () => {
                      that.$Modal.confirm({
                        title: '删除确认',
                        content: '是否确认删除该条记录？',
                        onOk: () => {
                          that.delete(params.row.id)
                        }
                      })
                    }
                  }
                },
                "删除"
              ),
            ]);
          }
        }
      ],
      pageNum: 1,
      pageSize: 10,
      data:[],
      loading: true,
      total: 0,
    };
  },
  computed: {
    
  },
  methods: {

    closeModel(){
      this.editModal = false;

    },

    editSubmit(){

      this.$refs.editForm.validate((valid) => {
        if (valid) {
          var url = this.urlobj.saveJczlRegistrationPersonnel
          

          if (this.editData.communityData && this.editData.communityData.length > 0) {
            this.editData.community = this.editData.communityData[this.editData.communityData.length-1]
          } else if(!this.editData.community){
            this.$Message.error("请选择社区");
            return;
          }
          this.btnLoading = true
          this.$post(url,this.editData).then(res => {
            if(res.isSucceed){
              this.$Message.success('保存成功')
              this.loadData()
            }else{
              this.$Message.error(res.message)
            }
          }).catch(e => {
            this.btnLoading = false
            this.$Message.error('保存失败')
          }).finally(() => {
            this.btnLoading = false
            this.editModal = false;
          })
        } else {
          this.$Message.error("请检查输入项");
        }
      });
      
    },

    edit(item){
      this.editModal = true;
      this.editData = {
        id: item.id,
        name: item.name,
        community: item.community,
        unit: item.unit,
        position: item.position,
        address: item.address,
        tel: item.tel,
        communityData:[]
      }
    },

    getCommunity() {
      this.$get(this.urlobj.getCommunityCascade, {
        communityId: this.$store.state.streetorcommunityid,
        nationwide: 1,
      })
      .then((res) => {
        this.communityList = res.rows.length
          ? this.formateData(res.rows)
          : [];
        console.log(this.communityList);
      })
      .catch((e) => {
        this.$Message.error("获取行政区域失败");
      });
    },

    //处理行政区域数据
    formateData(data){
      let returnData = data.map(item => {
          return {
              value:item.communityName,
              label:item.communityName,
              children:item.children.length?this.formateData(item.children):[]
          }
      })
      return returnData;
    },

    handleSuccess(e) {
      console.log(e);
      this.uploadLoading = false;
      if (e.isSucceed) {
        this.$Message.success(e.message);
        this.loadData();
      } else {
        this.$Message.error(e.message);
      }
    },

    handleError(e) {
      console.log(e);
      this.uploadLoading = false;
      this.$Message.error("导入失败");
    },

    handleProgress() {
      this.uploadLoading = true;
    },

    async delete(id){
      let url = this.urlobj.delJczlRegistrationPersonnel;
      let data = {
        id:id
      }
      this.$get(url,data)
      .then(res => {
        this.$Modal.confirm({
          title: "提示",
          content:res.isSucceed ? '删除成功！' : res.message,
          // 只要确定按钮显示
          onCancel: () => {
            this.loadData();
          },
          onOk: () => {
            this.loadData();
          }
        })
      })
      .catch(e => console.error(e))
    },
    
    async exportFile(){
       try {
        const exportConfigs = [
          {
            url:'https://shequyun.cn/dx_img/xlsx/东乡区机关企事业单位党员干部居住情况.xlsx',
            name: '东乡区机关企事业单位党员干部居住情况.xlsx'
          },
        ];
        
        // 顺序下载
        for (const config of exportConfigs) {
          await this.downloadFileWithName(config.url, config.name);
        }
        
        this.$Message.success('文件导出成功！');
      } catch (error) {
        console.error('导出失败:', error);
        this.$Message.error('文件导出失败！');
      }
    },
    downloadFileWithName(url, fileName) {
      return new Promise((resolve, reject) => {
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.style.display = 'none';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        setTimeout(resolve, 500); // 添加延迟确保下载开始
      });
    },
    auditRequest(id){
      let url = this.urlobj.reviewRecordJczlRegistrationRecord;
      this.$get(url,{
        id:id
      })
      .then(res => {
        if (res.isSucceed) {
          this.loadData();
        }else{
          this.$Modal.confirm({
            title: "提示",
            content: res.message
          });
        }
      })
    },
    searchReset(){
      this.pageNum = 1
      this.pageSize = 10
      this.query.community = "";
      this.comList = []
      this.$refs.searchForm.resetFields();
      
      this.loadData();
    },
    loadData(){
      this.loading = true

      if (this.comList && this.comList.length > 0) {
        this.query.community = this.comList[this.comList.length-1]
      }
      
      let url = this.urlobj.listJczlRegistrationPersonnel;
      var data = { 
        page: this.pageNum,
        rows: this.pageSize,
        ...this.query
      };
      this.$get(url,data)
      .then(res => {
        this.data = res.rows
        this.total = res.total
        if (!res.isSucceed) {
          this.$Modal.confirm({
            title: "提示",
            content: res.message
          });
        }
        this.loading=false
      })
      .catch(e => {
        this.loading=false
        console.error(e)
      })
    },

    changePageSize(val){
      this.pageSize = val
      this.loadData()
    },
    page(val) {
      this.pageNum = val;
      this.loadData()
    },
    
  },
  mounted() {
    this.actionuri = this.urlobj.importRegistrationPersonnel;
    this.loadData()
  },
  created() {
    this.getCommunity();
    that = this;
  }
};
</script>
<style lang='less' scoped>
.wrapper {
  color: #666666;
  height: 100%;
}

.wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.header {
  font-size: 25px;
  text-align: center;
}
.addManager {
  position: absolute;
  right: 20px;
}
.content {
  //   @content();
  // max-width: 96%;
  margin: 20px;
  margin-top: 0;
  // background: #fff;
  // padding: 0 15px 0 15px;
  &::-webkit-scrollbar {
    display: none;
  }
  .select-wrapper {
    font-size: 16px;
    margin-bottom: 20px;
    .name {
      margin-bottom: 10px;
    }
    .input {
      width: 30%;
    }
  }
  .card {
    height: 100%;
  }
  /deep/ .ivu-table-overflowX {
    overflow-x: hidden !important;
  }
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
}
.table-tabs {
  max-width: 100%;
  padding: 0;
  margin-top: 30px;

  /deep/ .ivu-tabs-bar {
    margin-bottom: 0;
    border-bottom: 0;
  }
  /deep/ .ivu-tabs-tab-active {
    color: white;
    background: #fe7d43;
    border-radius: 5px 5px 0 0;
  }
  /deep/ .ivu-tabs-ink-bar {
    height: 0px;
  }
  /deep/ .ivu-tabs-nav {
    padding-left: 10px;
    color: black;
  }
}

.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 450px);
}
.page {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.code-img {
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 172px;
  height: 172px;
  img {
    width: 172px;
    height: 172px;
  }
}
.text {
  font-size: 16px;
  span {
    text-decoration: underline;
    color: #fe7d43;
  }
}
/deep/ .ivu-table-tip table td{
  width: 100% !important;
}
/deep/ th .ivu-table-cell span {
  font-weight: bold !important;
}

/deep/.communityData .ivu-input::placeholder {
color: #111 !important;
}
</style>
